import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import useAuthToken from './hooks/authUtils';
import { fetchCurrentUser } from './modules/users';
import { useEffect, useState } from 'react';

export default function PrivateRoutes() {
  const token = useAuthToken();
  const location = useLocation();
  const navigate = useNavigate();
  const [currentUserRole, setCurrentUserRole] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('role') || 'null');
    } catch {
      return null;
    }
  });

  const getCurrentUser = async () => {
    try {
      const user = await fetchCurrentUser();
      const localRole = currentUserRole;

      if (user.role && localRole && user.role !== localRole) {
        alert("Your role in this organization has been updated. The page will reload to reflect the changes.");
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('role', JSON.stringify(user.role));
        localStorage.setItem('roleUpdated', JSON.stringify(true));
        setCurrentUserRole(user.role);
        setTimeout(() => {
          window.location.reload();
          localStorage.removeItem('roleUpdated');
        }, 200);
      }
      if (user?.role === 'super-admin' && location.pathname === '/dashboard') {
        navigate('/admin/dashboard', { replace: true });
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    if (currentUserRole && currentUserRole === 'team-member' && location.pathname === '/users') {
      navigate('/dashboard')
    } 
    if (currentUserRole && currentUserRole !== 'super-admin' && location.pathname === '/admin/dashboard') {
      navigate('/unauthorized')
    } 
    getCurrentUser();
  }, [location.pathname, currentUserRole]);

  const isAuth = () => token ? true : false;

  return isAuth() ? <Outlet /> : <Navigate to="/login" />;
}
